import {createFileRoute, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getPostLoginRedirectPathFromSearchString} from "~/utilities/postLoginRedirect";

export const Route = createFileRoute("/_withAuthenticationStatus/_notAuthenticated")({
    beforeLoad: async ({context, location}) => {
        if (context.authenticationStatus.isAuthenticated === true) {
            console.groupCollapsed("User is already authenticated, doing nothing and redirecting");
            console.log("authenticationStatus", context.authenticationStatus);
            console.groupEnd();

            const redirectTo = getPostLoginRedirectPathFromSearchString({
                intellsysBaseUrl: context.intellsysBaseUrl,
                searchStr: location.searchStr,
            });

            throw redirect({
                href: redirectTo,
            });
        }

        return {authenticationStatus: context.authenticationStatus};
    },
    loader: async () => {},
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
